import React from 'react';
import './ModalDialog.css';
import { InfoAlertIcon, WarningAlertIcon } from '../../Icons/AlertIcons/AlertIcons';

export interface ModalButton {
	buttonText: string;
	onClick: () => void;
	disabled?: boolean;
}

export enum ModalType {
	Info = 'info',
	Warning = 'warning',
}

export interface ModalProps {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	description: string;
	type?: ModalType;
	primaryButton: ModalButton;
	secondaryButton: ModalButton;
}

export const ModalDialog: React.FC<ModalProps> = ({
	isOpen,
	onClose,
	title,
	description,
	type = ModalType.Info,
	primaryButton,
	secondaryButton,
}) => {
	if (!isOpen) return null;

	// Calculate icon and border color based on type
	const Icon =
		type === ModalType.Warning ? (
			<WarningAlertIcon height={24} width={24} />
		) : (
			<InfoAlertIcon height={24} width={24} />
		);
	const borderColor = type === ModalType.Warning ? '#D15700' : '#0045DB';

	const handlePrimaryButtonClick = () => {
		primaryButton.onClick();
		onClose();
	};

	const handleSecondaryButtonClick = () => {
		secondaryButton.onClick();
		onClose();
	};

	return (
		<div className="modal-backdrop" role="dialog" aria-modal="true" tabIndex={-1}>
			<div className="modal-container">
				<div className="modal-content" style={{ borderTopColor: borderColor }}>
					<div className="modal-header">
						<div className="modal-icon">{Icon}</div>
						<h2 className="modal-title">{title}</h2>
					</div>

					<div className="modal-body">
						<p className="modal-description">{description}</p>
					</div>

					<div className="modal-footer">
						<button
							className="modal-button modal-button-primary"
							onClick={handlePrimaryButtonClick}
							disabled={primaryButton.disabled}
						>
							{primaryButton.buttonText}
						</button>
						<button
							className="modal-button modal-button-secondary"
							onClick={handleSecondaryButtonClick}
							disabled={secondaryButton.disabled}
						>
							{secondaryButton.buttonText}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
